import { useFloating as d, autoUpdate as g } from "@floating-ui/vue";
import { ref as o, computed as y } from "vue";
import { SfPopoverPlacement as v, SfPopoverStrategy as P } from "@storefront-ui/shared";
function b(a) {
  const {
    referenceRef: e = o(),
    floatingRef: t = o(),
    isOpen: r = !1,
    middleware: n,
    placement: l = v.bottom,
    strategy: i = P.absolute
  } = a, { strategy: p, x: m, y: s, middlewareData: f, placement: u } = d(e, t, {
    strategy: i,
    placement: l,
    open: r,
    middleware: n,
    whileElementsMounted: g
  }), c = y(() => ({
    position: p.value,
    top: `${s.value ?? 0}px`,
    left: `${m.value ?? 0}px`
  }));
  return { referenceRef: e, floatingRef: t, style: c, middlewareData: f, placement: u };
}
export {
  b as usePopover
};
